module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ibcontainer"
  }, [_c('button', {
    staticClass: "ib medium",
    style: ({
      borderColor: _vm.border_color,
      backgroundColor: _vm.background_color,
      minWidth: _vm.min_width,
      maxWidth: _vm.max_width
    }),
    attrs: {
      "disabled": _vm.disabled == false
    }
  }, [_c('icon', {
    staticClass: "ibi",
    attrs: {
      "name": _vm.icon,
      "scale": "1",
      "color": _vm.icon_color
    }
  }), _vm._v("  "), _c('span', {
    style: ({
      color: _vm.text_color
    })
  }, [_vm._v(_vm._s(_vm.text))])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-bf891132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/IconButton/Index.vue
// module id = 2182
// module chunks = 0